

// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// import "./JourneyTimeline.css";

// export default function JourneyTimeline() {


//   const journeyData = [
//     {
//       year: "2019",
//       month: "June / 2019",
//       title: "Company Founded",
//       description:
//         "StructGuard Engineers LLP was founded in Pune with a vision to deliver precise and reliable structural engineering solutions.",
//       image: "/journey/2019.jpg",
//     },
//     {
//       year: "2020",
//       month: "March / 2020",
//       title: "First Major Project",
//       description:
//         "Successfully delivered our first residential and commercial structural design projects.",
//       image: "/journey/2020.jpg",
//     },
//     {
//       year: "2021",
//       month: "August / 2021",
//       title: "Service Expansion",
//       description:
//         "Expanded into BIM modeling, detailed structural drawings, and global client support.",
//       image: "/journey/2021.jpg",
//     },
//     {
//       year: "2022",
//       month: "May / 2022",
//       title: "Industrial Projects",
//       description:
//         "Started delivering industrial sheds, foundations, and infrastructure projects.",
//       image: "/journey/2022.jpg",
//     },
//     {
//       year: "2023",
//       month: "September / 2023",
//       title: "Growing Team & Clients",
//       description:
//         "Crossed multiple milestones with consistent delivery and long-term clients.",
//       image: "/journey/2023.jpg",
//     },
//     {
//       year: "2024",
//       month: "April / 2024",
//       title: "Advanced BIM & Tools",
//       description:
//         "Implemented advanced BIM workflows and modern structural analysis tools.",
//       image: "/journey/2024.jpg",
//     },
//     {
//       year: "2025",
//       month: "January / 2025",
//       title: "Future Vision",
//       description:
//         "Focused on innovation, larger projects, and international engineering collaborations.",
//       image: "/journey/2025.jpg",
//     },
//   ];



//   const [index, setIndex] = useState(1);

//   const next = () => {
//     if (index < journeyData.length - 1) setIndex(index + 1);
//   };

//   const prev = () => {
//     if (index > 0) setIndex(index - 1);
//   };

//   const item = journeyData[index];

//   return (
//     <div className="timeline-wrapper">
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={item.year}
//           className="timeline-slide"
//           initial={{ opacity: 0, x: 80 }}
//           animate={{ opacity: 1, x: 0 }}
//           exit={{ opacity: 0, x: -80 }}
//           transition={{ duration: 0.6 }}
//         >
//           {/* BIG BACKGROUND YEAR */}
//           <div className="bg-year">{item.year}</div>

//           {/* LINE */}
//           <div className="line">
//             <span className="dot left" />
//             <span className="dot right" />
//           </div>

//           {/* IMAGE */}
//           <div className="image-circle">
//             <img src={item.image} alt={item.title} />
//           </div>

//           {/* TEXT */}
//           <div className="text-box">
//             <h4>{item.month}</h4>
//             <h2>{item.title}</h2>
//             <p>{item.description}</p>
//           </div>
//         </motion.div>
//       </AnimatePresence>

//       {/* NAVIGATION */}
//       <div className="nav">
//         <button onClick={prev}>‹</button>
//         <div className="progress">
//           {journeyData.map((_, i) => (
//             <span key={i} className={i === index ? "active" : ""} />
//           ))}
//         </div>
//         <button onClick={next}>›</button>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import imgbg from '../Images/top-view-measuring-tools-still-life.jpg'
const journeyData = [
    {
        year: "2019",
        month: "June / 2019",
        title: "Company Founded",
        description:
            "StructGuard Engineers LLP was founded in Pune with a vision to deliver precise and reliable structural engineering solutions.",
        image: imgbg,
    },
    {
        year: "2020",
        month: "March / 2020",
        title: "First Major Project",
        description:
            "Successfully delivered our first residential and commercial structural design projects.",
        image: imgbg,
    },
    {
        year: "2021",
        month: "August / 2021",
        title: "Service Expansion",
        description:
            "Expanded into BIM modeling, detailed structural drawings, and global client support.",
        image: imgbg,
    },
    {
        year: "2022",
        month: "May / 2022",
        title: "Industrial Projects",
        description:
            "Started delivering industrial sheds, foundations, and infrastructure projects.",
        image: imgbg,
    },
    {
        year: "2023",
        month: "September / 2023",
        title: "Growing Team & Clients",
        description:
            "Crossed multiple milestones with consistent delivery and long-term clients.",
        image: imgbg,
    },
    {
        year: "2024",
        month: "April / 2024",
        title: "Advanced BIM & Tools",
        description:
            "Implemented advanced BIM workflows and modern structural analysis tools.",
        image: imgbg,
    },
    {
        year: "2025",
        month: "January / 2025",
        title: "Future Vision",
        description:
            "Focused on innovation, larger projects, and international engineering collaborations.",
        image: imgbg,
    },
];

export default function JourneyTimeline() {
    const [index, setIndex] = useState(1);
    const item = journeyData[index];



    return (

        <>


            <div style={styles.wrapper}>

                <h2 style={{ color: "#0A1733", fontSize: '60px', textAlign: 'center' }}>
                    StructGuard<span style={{ color: '#f37021' }}> Journey</span>
                </h2>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={item.year}
                        initial={{ opacity: 0, x: 80 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -80 }}
                        transition={{ duration: 0.6 }}
                        style={styles.slide}
                    >
                        {/* BIG BACKGROUND YEAR */}
                        <div style={styles.bgYear}>{item.year}</div>

                        {/* LINE */}
                        <div style={styles.line}>
                            <span style={{ ...styles.dot, left: "15%" }} />
                            <span style={{ ...styles.dot, right: "15%" }} />
                        </div>

                        {/* IMAGE */}
                        <div style={styles.imageCircle}>
                            <img src={item.image} alt={item.title} style={styles.image} />
                        </div>

                        {/* TEXT */}
                        <div style={styles.textBox}>
                            <h4 style={styles.month}>{item.month}</h4>
                            <h2 style={styles.title}>{item.title}</h2>
                            <p style={styles.desc}>{item.description}</p>
                        </div>
                    </motion.div>
                </AnimatePresence>

                {/* NAVIGATION */}
                <div style={styles.nav}>
                    <button
                        onClick={() => index > 0 && setIndex(index - 1)}
                        style={styles.arrow}
                    >
                        ‹
                    </button>

                    <div style={styles.progress}>
                        {journeyData.map((_, i) => (
                            <span
                                key={i}
                                style={{
                                    ...styles.progressDot,
                                    background: i === index ? "#000" : "#aaa",
                                }}
                            />
                        ))}
                    </div>

                    <button
                        onClick={() =>
                            index < journeyData.length - 1 && setIndex(index + 1)
                        }
                        style={styles.arrow}
                    >
                        ›
                    </button>
                </div>
            </div>
        </>
    );
}

/* ================= INLINE STYLES ================= */

const styles = {
    wrapper: {
        background: "white",
        minHeight: "80vh",
        padding: "60px",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Inter, sans-serif",
    },

    slide: {
        position: "relative",
        height: "100%",
    },

    bgYear: {
        position: "absolute",
        right: "5%",
        top: "20%",
        fontSize: "420px",
        fontWeight: "700",
        color: "#F37021",
        lineHeight: "1",
        userSelect: "none",
    },

    line: {
        position: "absolute",
        top: "45%",
        left: 0,
        right: 0,
        height: "2px",
        background: "#0A1733",
    },

    dot: {
        position: "absolute",
        top: "-6px",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        background: "#0A1733",
    },

    imageCircle: {
        position: "absolute",
        top: "35%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "260px",
        height: "260px",
        borderRadius: "50%",
        overflow: "hidden",
    },

    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },

    textBox: {
        position: "absolute",
        left: "10%",
        top: "55%",
        maxWidth: "360px",
    },

    month: {
        fontWeight: "600",
        marginBottom: "8px",
    },

    title: {
        fontSize: "28px",
        marginBottom: "12px",
    },

    desc: {
        fontSize: "16px",
        lineHeight: "1.6",
        color: "#333",
    },

    nav: {
        position: "absolute",
        bottom: "20px", // ✅ FIXED
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
    },

    arrow: {
        fontSize: "42px",
        background: "none",
        border: "none",
        cursor: "pointer",
    },

    progress: {
        display: "flex",
        gap: "8px",
    },

    progressDot: {
        width: "30px",
        height: "4px",
        transition: "0.3s",
    },
};
